// import { Link } from 'gatsby'
import React from 'react'
import Image from '../../function/Image'
import Heading from '../Heading/Heading'
import IconLink from '../IconLink/IconLink'
const HeroIconBlock = ({ heroIconBlock }) => {
    const { headingType, iconLinks, logo, title, headingFontSize } =
        heroIconBlock || {}
    return (
        <div className="container text-center hero-icon-block">
            <div className="w-[175px] mx-auto h-[110px] shadow-dark_purple/10 shadow-[0_10px_40px] rounded-[10px] grid place-items-center bg-white px-9 mb-[30px]">
                {logo && <Image {...logo} objectFit="contain" className="!object-contain" />}
            </div>

            {title && (
                <Heading heading={headingType}>
                    <span
                        className={`leading-none  ${
                            headingFontSize ? '' : 'md:text-6xl text-5xl '
                        }`}
                        style={{ fontSize: `${headingFontSize}px` }}
                    >
                        {title}
                    </span>
                </Heading>
            )}

            <div className="grid place-items-center mt-10">
                <div className="grid sm:grid-cols-2 xl:grid-cols-4 xl:flex gap-2 sm:gap-x-10">
                    {iconLinks?.map((item, index) => {
                        return (
                            <IconLink
                                key={index}
                                icon={item?.icon}
                                link={item?.link}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default HeroIconBlock
